import {post} from 'aws-amplify/api';
import {Command, type PostMethod} from '../../Command';

export interface ForgotPasswordUserInput {
  email: string;
  locale: 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt';
}

export class ForgotPasswordUserCommand extends Command<PostMethod> {
  constructor({email, locale}: ForgotPasswordUserInput) {
    super(post, {
      path: '/forgotpassword',
      options: {
        body: {
          email,
          locale,
        },
      },
    });
  }

  async deserialize(output: ReturnType<typeof post>): Promise<void> {
    await output.response;
  }
}
